import * as Yup from "yup";

export const validationNewCourse = Yup.object({
	CourseId: Yup.number().required("Course is required"),
	SessionDate: Yup.date().required("Session date is required"),
	ExpiresDate: Yup.date().nullable(),
	TrainerId: Yup.number().nullable().required("Trainer is required"),
	GroupId: Yup.number().nullable(),
	Information: Yup.string().max(
		500,
		"Information must be 500 characters or less",
	),
});

export const tabs = [
	{
		name: "Dashboard",
		index: 0,
		hasIcon: false,
		// translationKey: "Training.TabPanel.Courses",
	},
	{
		name: "Courses",
		index: 1,
		hasIcon: false,
		translationKey: "Training.TabPanel.Courses",
	},
	{
		name: "Drills",
		index: 2,
		hasIcon: false,
		translationKey: "Training.TabPanel.Drills",
	},
	{
		name: "Archived Sessions",
		index: 3,
		hasIcon: false,
		translationKey: "Training.TabPanel.ArchivedSessions",
	},
	{
		name: "Planner",
		index: 4,
		hasIcon: false,
		translationKey: "Training.TabPanel.Planner",
	},
	{
		name: "Settings",
		index: 5,
		hasIcon: false,
		translationKey: "Training.TabPanel.Settings",
		externalUrl: `${window.location.origin}/settings`,
	},
];
